const DEFAULT_OPTIONS = {
  unit: "px"
};
const cssPropertySizeValue = (value, optionsArgs) => {
  const options = {
    ...DEFAULT_OPTIONS,
    ...optionsArgs
  };
  if (typeof value === "number") {
    return `${value}${options.unit}`;
  }
  return value;
};
const cssProperty = (property, value) => {
  return `${property}: ${cssPropertySizeValue(value)};`;
};

export { cssProperty, cssPropertySizeValue };
//# sourceMappingURL=cssProperties.js.map
